/**
 * Custom Product Carousel for Altesse Studio
 * Ce script transforme l'affichage des images produit sur mobile en carrousel
 * au lieu d'afficher toutes les images empilées verticalement
 * Support pour gallery-gravure
 */

document.addEventListener("DOMContentLoaded", function () {
  // Exécuter uniquement sur les écrans mobiles (largeur < 768px)
  if (window.innerWidth < 768) {
    initProductImageCarousel();
  }

  // Réinitialiser le carrousel lors du redimensionnement de la fenêtre
  window.addEventListener("resize", function () {
    if (window.innerWidth < 768) {
      initProductImageCarousel();
    } else {
      // Restaurer l'affichage normal sur desktop si nécessaire
      resetProductImageDisplay();
    }
  });
});

/**
 * Initialise le carrousel d'images produit sur mobile
 */
function initProductImageCarousel() {
  // Chercher tous les conteneurs d'images produit
  const mediaContainers = document.querySelectorAll(
    ".product__primary-left .product__media-container.below-mobile, .gallery-gravure .product__media-container.below-mobile"
  );

  mediaContainers.forEach(mediaContainer => {
    if (!mediaContainer) return;

    const mediaItems = mediaContainer.querySelectorAll(".product__media-item");
    if (mediaItems.length <= 1) return; // Pas besoin de carrousel s'il n'y a qu'une seule image

    // Vérifier si le carrousel est déjà initialisé
    if (mediaContainer.classList.contains("carousel-initialized")) return;

    // Cacher toutes les images sauf la première
    mediaItems.forEach((item, index) => {
      if (index === 0) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });

    // Créer les contrôles de navigation
    const carouselControls = document.createElement("div");
    carouselControls.className = "product-carousel-controls";
    carouselControls.innerHTML = `
      <button class="carousel-prev" aria-label="Image précédente">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 4l-8 8 8 8" stroke="currentColor" stroke-width="2"></path>
        </svg>
      </button>
      <div class="carousel-indicators"></div>
      <button class="carousel-next" aria-label="Image suivante">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="2"></path>
        </svg>
      </button>
    `;

    // Ajouter les indicateurs de position
    const indicatorsContainer = carouselControls.querySelector(
      ".carousel-indicators",
    );
    for (let i = 0; i < mediaItems.length; i++) {
      const indicator = document.createElement("button");
      indicator.className = "carousel-indicator";
      indicator.setAttribute("data-index", i);
      indicator.setAttribute("aria-label", `Aller à l'image ${i + 1}`);
      if (i === 0) indicator.classList.add("active");

      indicator.addEventListener("click", function () {
        goToSlide(i, mediaContainer);
      });

      indicatorsContainer.appendChild(indicator);
    }

    // Ajouter les contrôles au conteneur
    mediaContainer.appendChild(carouselControls);

    // Ajouter les gestionnaires d'événements pour les boutons de navigation
    const prevButton = carouselControls.querySelector(".carousel-prev");
    const nextButton = carouselControls.querySelector(".carousel-next");

    prevButton.addEventListener("click", function () {
      const currentIndex = getCurrentIndex(mediaContainer);
      const newIndex =
        currentIndex === 0 ? mediaItems.length - 1 : currentIndex - 1;
      goToSlide(newIndex, mediaContainer);
    });

    nextButton.addEventListener("click", function () {
      const currentIndex = getCurrentIndex(mediaContainer);
      const newIndex =
        currentIndex === mediaItems.length - 1 ? 0 : currentIndex + 1;
      goToSlide(newIndex, mediaContainer);
    });

    // Ajouter la prise en charge du swipe
    let touchStartX = 0;
    let touchEndX = 0;

    mediaContainer.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true },
    );

    mediaContainer.addEventListener(
      "touchend",
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe(mediaContainer);
      },
      { passive: true },
    );

    function handleSwipe(container) {
      const currentIndex = getCurrentIndex(container);
      const items = container.querySelectorAll(".product__media-item");

      if (touchEndX < touchStartX - 50) {
        // Swipe gauche -> image suivante
        const newIndex =
          currentIndex === items.length - 1 ? 0 : currentIndex + 1;
        goToSlide(newIndex, container);
      }

      if (touchEndX > touchStartX + 50) {
        // Swipe droite -> image précédente
        const newIndex =
          currentIndex === 0 ? items.length - 1 : currentIndex - 1;
        goToSlide(newIndex, container);
      }
    }

    // Variables pour la limitation du défilement
    let wheelThrottleTimeout = null;
    let lastWheelTime = 0;
    const wheelThrottleDelay = 800; // Délai en millisecondes entre chaque changement d'image (plus élevé = plus lent)
    let wheelDeltaSum = 0;
    const wheelDeltaThreshold = 50; // Seuil de défilement à atteindre pour changer d'image

    // Ajouter la prise en charge du défilement horizontal via le pavé tactile
    mediaContainer.addEventListener(
      "wheel",
      function (e) {
        // Empêcher le défilement vertical de la page si le défilement est principalement horizontal
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          e.preventDefault();

          // Accumuler les valeurs de deltaX
          wheelDeltaSum += e.deltaX;

          // Vérifier si nous avons dépassé le seuil et si le délai est écoulé
          const now = Date.now();
          if (
            Math.abs(wheelDeltaSum) >= wheelDeltaThreshold &&
            now - lastWheelTime >= wheelThrottleDelay
          ) {
            const currentIndex = getCurrentIndex(mediaContainer);
            const items = mediaContainer.querySelectorAll(".product__media-item");

            if (wheelDeltaSum > 0) {
              // Défilement vers la droite -> image suivante
              const newIndex =
                currentIndex === items.length - 1 ? 0 : currentIndex + 1;
              goToSlide(newIndex, mediaContainer);
            } else {
              // Défilement vers la gauche -> image précédente
              const newIndex =
                currentIndex === 0 ? items.length - 1 : currentIndex - 1;
              goToSlide(newIndex, mediaContainer);
            }

            // Réinitialiser les variables
            lastWheelTime = now;
            wheelDeltaSum = 0;
          }
        }
      },
      { passive: false },
    );

    // Marquer le carrousel comme initialisé
    mediaContainer.classList.add("carousel-initialized");
  });

  // Fonction pour obtenir l'index actuel
  function getCurrentIndex(container) {
    const mediaItems = container.querySelectorAll(".product__media-item");
    for (let i = 0; i < mediaItems.length; i++) {
      if (!mediaItems[i].classList.contains("hidden")) {
        return i;
      }
    }
    return 0;
  }

  // Fonction pour aller à une diapositive spécifique
  function goToSlide(index, container) {
    const mediaItems = container.querySelectorAll(".product__media-item");
    const indicatorsContainer = container.querySelector(".carousel-indicators");
    
    // Masquer toutes les images
    mediaItems.forEach((item) => {
      item.classList.add("hidden");
    });

    // Afficher l'image sélectionnée
    mediaItems[index].classList.remove("hidden");

    // Mettre à jour les indicateurs
    const indicators = indicatorsContainer.querySelectorAll(
      ".carousel-indicator",
    );
    indicators.forEach((indicator) => {
      indicator.classList.remove("active");
    });
    indicators[index].classList.add("active");
  }
}

/**
 * Réinitialise l'affichage des images produit à leur état d'origine
 */
function resetProductImageDisplay() {
  const mediaContainers = document.querySelectorAll(
    ".product__primary-left .product__media-container.below-mobile, .gallery-gravure .product__media-container.below-mobile"
  );

  mediaContainers.forEach(mediaContainer => {
    if (!mediaContainer) return;

    // Si le carrousel n'est pas initialisé, ne rien faire
    if (!mediaContainer.classList.contains("carousel-initialized")) return;

    // Afficher toutes les images
    const mediaItems = mediaContainer.querySelectorAll(".product__media-item");
    mediaItems.forEach((item) => {
      item.classList.remove("hidden");
    });

    // Supprimer les contrôles de navigation
    const carouselControls = mediaContainer.querySelector(
      ".product-carousel-controls",
    );
    if (carouselControls) {
      carouselControls.remove();
    }

    // Marquer le carrousel comme non initialisé
    mediaContainer.classList.remove("carousel-initialized");
  });
}